import { useStore } from "../store";

export function TopBar() {
  const user = useStore((s) => s.user);
  const logout = useStore((s) => s.logout);
  const connections = useStore((s) => s.connections);
  const activeId = useStore((s) => s.activeConnectionId);
  const setActive = useStore((s) => s.setActiveConnection);
  const reload = useStore((s) => s.loadPage);

  const active = connections.find((c) => c.id === activeId) ?? null;

  return (
    <header className="topbar">
      <div className="brand">
        <img src="/hle-icon.png" alt="" className="logo" />
        <div className="divider" />
        <h1>Hal Leonard Europe</h1>
      </div>

      <div className="topbar-mid">
        {connections.length > 1 ? (
          <select
            className="conn-select"
            value={activeId ?? ""}
            onChange={(e) => setActive(e.target.value)}
          >
            {connections.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        ) : (
          active && (
            <span className="conn-label">
              {active.name}
              <span className="conn-meta">
                {active.engine} &middot; {active.host}/{active.database}
              </span>
            </span>
          )
        )}
      </div>

      <div className="actions">
        <button className="btn ghost" title="Reload data" onClick={() => void reload(true)}>
          &#x21bb;
        </button>
        <span className="user-name">{user?.name ?? ""}</span>
        {user?.isAdmin && <span className="badge">ADMIN</span>}
        <button className="btn ghost" onClick={() => void logout()}>
          Sign out
        </button>
      </div>
    </header>
  );
}
